import { getAudioContext, scaledGain } from './audioState';

// Ring sound utility for patient called notifications.
//
// The AudioContext and the peak gain both come from `audioState`, so the
// volume slider in Settings → Notifications governs this ring and the general
// beep together rather than each carrying its own hardcoded level.
let isRinging = false;
let ringInterval: ReturnType<typeof setInterval> | null = null;

const playRingTone = () => {
  const ctx = getAudioContext();
  if (!ctx) return;

  const playTone = (freq: number, start: number, dur: number) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = freq;
    osc.type = 'sine';
    const peak = scaledGain(0.4);
    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(peak, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(
      Math.max(peak * 0.03, 0.0001),
      start + dur,
    );
    osc.start(start);
    osc.stop(start + dur);
  };

  const now = ctx.currentTime;
  // Ring pattern: two quick tones repeated
  playTone(880, now, 0.15);
  playTone(1100, now + 0.18, 0.15);
  playTone(880, now + 0.4, 0.15);
  playTone(1100, now + 0.58, 0.15);
};

export const startRinging = () => {
  if (isRinging) return;
  isRinging = true;

  // Play immediately
  playRingTone();

  // Repeat every 1.5 seconds
  ringInterval = setInterval(() => {
    if (isRinging) {
      playRingTone();
    }
  }, 1500);
};

export const stopRinging = () => {
  isRinging = false;
  if (ringInterval) {
    clearInterval(ringInterval);
    ringInterval = null;
  }
};

export const isCurrentlyRinging = () => isRinging;
